import type { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';

export type FastApiErrorData = { detail?: string | { msg: string }[] };

export const useHandleError = () => {
  const { enqueueSnackbar } = useSnackbar();
  const handleError = (errorResponse: AxiosError, errorMessage: string) => {
    if (errorResponse.response?.status === 503) {
      console.error(
        'Response error 503 from ',
        errorResponse.request?.responseURL,
        errorResponse.response
      );
      return;
    }

    if (!errorResponse.response) {
      console.error('Unknown Error:', errorResponse);
      enqueueSnackbar(`Unknown Error:\n ${errorResponse.message}`, {
        style: { whiteSpace: 'pre-line' },
        variant: 'error'
      });
      return;
    }

    const detail = (errorResponse as AxiosError<FastApiErrorData>)?.response
      ?.data?.detail;
    const detailString = typeof detail === 'string' ? detail : '';
    const match = detailString.match(/\[(\d+)\]/);
    const id = match ? match[1] : null;
    const errorId = id && !(errorMessage || '').startsWith('[') ? `-${id}` : '';

    enqueueSnackbar(
      `[${errorResponse?.response?.status}${errorId}] ${errorResponse?.response?.statusText}\n ${errorMessage}`,
      {
        style: { whiteSpace: 'pre-line' },
        variant: 'error'
      }
    );
  };

  return handleError;
};

export const getFastApiValueError = (
  errorResponse: AxiosError<FastApiErrorData>
): string | null => {
  const detail = errorResponse?.response?.data?.detail;
  if (
    Array.isArray(detail) &&
    detail.length > 0 &&
    typeof detail[0] === 'object' &&
    'msg' in detail[0]
  ) {
    return detail[0].msg;
  }
  return null;
};

export default useHandleError;
